module.exports = __webpack_public_path__ + "img/Season202425_DE600x200-2.dada235c.png";